import AppDispatcher from "../dispatcher/AppDispatcher";

import AppConstants from "../constants/AppConstants";

import TagStore from "../stores/TagStore";

import Api from "../utils/Api";

// TagActions
export default
{
	async initialize()
	{
		if (!TagStore.getIsInitialized()) {
			try
			{
				const tags = await Api.getTags();
				AppDispatcher.handleAction({
					actionType: AppConstants.TAGSTORE_RECEIVE_DATA,
					tags
				});
			}
			catch (err)
			{
				// TODO: BA-152 call a fail action
				console.error(err);
			}
		}
	},

	async saveTag(tag)
	{
		AppDispatcher.handleAction({
			actionType: AppConstants.TAGSTORE_SAVE_PENDING
		});

		try
		{
			tag = await Api.saveTag(tag);

			AppDispatcher.handleAction({
				actionType: AppConstants.TAGSTORE_SAVE_SUCCESS,
				tag
			});
			return tag;
		}
		catch (message)
		{
			AppDispatcher.handleAction({
				actionType: AppConstants.TAGSTORE_SAVE_FAILURE,
				message
			});
		}
	},

	async deleteTag(tagId)
	{
		AppDispatcher.handleAction({
			actionType: AppConstants.TAGSTORE_DELETE_PENDING,
			tagId
		});

		try
		{
			const tag = await Api.deleteTag(tagId);
			AppDispatcher.handleAction({
				actionType: AppConstants.TAGSTORE_DELETE_SUCCESS,
				tagId
			});
			return tag;
		}
		catch (message)
		{
			AppDispatcher.handleAction({
				actionType: AppConstants.TAGSTORE_DELETE_FAILURE,
				message
			});
		}
	}
};



// WEBPACK FOOTER //
// ./Components/actions/TagActions.jsx